'use strict';

import { environment } from '@quartz-gov-legacy/environments/environment';

angular.module('actionPlanModule')

.factory('grcActionPlanService', ['$http', '$q', function ($http, $q) {

    var baseUrl = environment.apiUrl + '/Pilot/api/Recom/ActionPlan';

    function returnData(response) {
        return response.data;
    }

    var service = {};

    // Retrieve Action Plans
    service.getActionPlan = function (actionPlanId) {
        return $http
                .get(baseUrl + '/' + actionPlanId)
                .then(function (response) { return response.data; });
    };
    service.getActionPlansByRecommendation = function (recomId) {
        return $http
                .get(baseUrl + '/ForRecommendation/' + recomId)
                .then(returnData);
    };


    // Actions on action plans
    service.createActionPlan = function (recommendationId, actionPlan) {
        return $http
                .post(environment.apiUrl + '/Pilot/api/Recom/Recommendation/' + recommendationId + '/ActionPlan',
                      actionPlan)
                .then(returnData);
    };
    service.updateActionPlan = function (actionPlan) {
        return $http
                .put(baseUrl + '/' + actionPlan.ActionPlanID,
                     actionPlan)
                .then(returnData);
    };
    service.deleteActionPlan = function (actionPlan) {
        return $http
                .delete(baseUrl + '/' + actionPlan.ActionPlanID)
                .then(returnData);
    };

    // Assessments
    service.getAllActionPlanAssessments = function (actionPlanId) {
        return $http
            .get(baseUrl + '/' + actionPlanId + '/Assessment')
            .then(returnData)
    };

    return service;
}]);
